import React from 'react';
import { Tooltip, AccountAvatar } from '@michelin/acid-components';
import { Grid } from '@material-ui/core';

interface CreatedByAvatarProps {
  customerType: string | null | undefined,
  customerNumber?: string | null,
  isMultiShipTo?: boolean,
}

export default function CreatedByAvatar({ customerType, customerNumber, isMultiShipTo }: CreatedByAvatarProps) {
  if (!customerType) return null;

  type CustomerType = 'PC' | 'HO' | 'BT' | 'ST' | 'MS';
  let ct: CustomerType;

  switch (customerType.toLowerCase().replace(' ', '').replace('_', '')) {
    case 'pc': ct = 'PC'; break;
    case 'ho': ct = 'HO'; break;
    case 'bt': ct = 'BT'; break;
    case 'st': ct = 'ST'; break;
    case 'ms': ct = 'MS'; break;
    case 'parentcompany': ct = 'PC'; break;
    case 'homeoffice': ct = 'HO'; break;
    case 'billto': ct = 'BT'; break;
    case 'shipto': ct = 'ST'; break;
    case 'multishipto': ct = 'MS'; break;
    default: return null;
  }

  if (isMultiShipTo) ct = 'MS';

  const avatar = (
    <div style={{ fontSize: '0', width: '100%' }}>
      <Grid container justify="center" alignItems="center">
        <Grid item>
          <AccountAvatar
            style={{ marginLeft: '7px' }}
            size="small"
            accountType={ct}
            name=""
            address=""
          />
        </Grid>
      </Grid>
    </div>
  );

  if (!customerNumber || ct === 'MS') return avatar;
  return (
    <Tooltip arrow title={`${ct} ${customerNumber.split('~').pop()}`}>{avatar}</Tooltip>
  );
}
